import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserProfile from '@gestor-web/@core/store/reducers/user-profile.reducers';
import { UsuarioFuncionalidade } from '@gestor-web/@core/api/ords/model';
import { resolverAbrangencia } from '@gestor-web/@core/auth/abrangencia';

export const selectUserProfile = createFeatureSelector<fromUserProfile.State>(fromUserProfile.featureKey);
export const selectUserKcProfile = createSelector(selectUserProfile, state => state.kc);
export const selectUserIdssProfile = createSelector(selectUserProfile, state => state.idss);
export const selectProfileIncomplete = createSelector(selectUserProfile, state => state.isIncomplete);
export const selectIsOffline = createSelector(selectUserProfile, state => state.isOffline);
/**
 * Equipe interna (Administrador e Super Administrador), pela `ib_administrador` do papel. Vem do
 * perfil, não do token: é falso até o perfil carregar.
 */
export const selectIsAdmin = createSelector(selectUserIdssProfile, idss => idss?.ib_administrador === 1);
export const selectAbrangenciaOperadoras = createSelector(selectUserIdssProfile, idss => resolverAbrangencia(idss));
export const selectOperadorasVinculadas = createSelector(selectUserProfile, state => state.operadorasVinculadas);
export const selectUserEmail = createSelector(selectUserIdssProfile, idss => idss?.ds_email);
export const selectFuncionalidades = createSelector(selectUserProfile, state => state.funcionalidades);
export const selectFuncionalidadesLoaded = createSelector(selectUserProfile, state => state.funcionalidades_loaded);
export const selectFuncionalidadesRegans = createSelector(selectUserProfile, state => state.funcionalidades_regans);
export const selectFuncionalidadesAcessiveis = createSelector(selectFuncionalidades, funcionalidades => {
  const acessiveis = new Set<string>();
  (funcionalidades ?? []).forEach(f => {
    if (f?.cd_funcionalidade && f.ib_desabilitado_aplicavel === 0) {
      acessiveis.add(f.cd_funcionalidade.toUpperCase().trim());
    }
  });
  return acessiveis;
});

/**
 * Mapa de código MAIÚSCULO -> funcionalidade. Diferente de `selectFuncionalidadesAcessiveis`
 * ("pode acessar?"), preserva os módulos da funcionalidade, necessários para decidir EXIBIÇÃO
 * (ver `PermissaoService.resolverAcesso`).
 */
export const selectFuncionalidadesMap = createSelector(selectFuncionalidades, funcionalidades => {
  const mapa = new Map<string, UsuarioFuncionalidade>();
  (funcionalidades ?? []).forEach(f => {
    if (f?.cd_funcionalidade) {
      mapa.set(f.cd_funcionalidade.toUpperCase().trim(), f);
    }
  });
  return mapa;
});

// Cookie Consent
export const selectCookieShowBanner = createSelector(selectUserProfile, state => state.cookiesBannerShow);
export const selectCookieAcceptAll = createSelector(selectUserProfile, state => state.cookiesAcceptAll);

// Cliente
export const selectLoginClienteIdp = createSelector(selectUserProfile, state => state.loginClienteIdp);
